// https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
export var get=function get(o,p){return p.reduce(function(xs,x){return xs&&xs[x]?xs[x]:null;},o);};